import type { BaseApiError } from '@lumapps/base-api';
import { useQuery, type UseQueryOptions } from '@lumapps/base-api/react-query';

import { getMicroApp, microAppsQueryKeys } from '../api';

type QueryOptions = UseQueryOptions<
    Awaited<ReturnType<typeof getMicroApp>>,
    BaseApiError,
    Awaited<ReturnType<typeof getMicroApp>>,
    ReturnType<typeof microAppsQueryKeys.getMicroApp>
>;

export const useMicroApp = (microAppId: string, options?: QueryOptions) =>
    useQuery({
        ...options,
        queryKey: microAppsQueryKeys.getMicroApp(microAppId),
        queryFn: ({ signal }) => getMicroApp(microAppId, signal),
        enabled: Boolean(microAppId) && (options?.enabled ?? true),
    });
